import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EMPTY, Observable } from 'rxjs';
import { SessionCookieGuardService } from '@core/services/session-cookie-guard.service';

/**
 * ITP2-14341 (Plan ITP-P-65). Before any request leaves, ask the session-cookie guard whether the session cookie was
 * removed. If it was, the guard has started the full logout and this request is dropped (it completes with no
 * response): a session the user ended must not keep signing calls with its in-memory token. Registered ahead of
 * AuthInterceptor in CoreModule, so a dropped request never gets an Authorization header.
 */
@Injectable()
export class SessionCookieInterceptor implements HttpInterceptor {
  constructor(private sessionCookieGuard: SessionCookieGuardService) {
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (this.sessionCookieGuard.endSessionIfCookieLost()) {
      return EMPTY;
    }
    return next.handle(req);
  }
}
